export function formatResponse(response) {
  return response["hydra:member"];
}
